<template>
    <v-row>
        <Loader v-if="loader"></Loader>
        <v-col cols="12">
            <v-card flat>
                <v-card-text>
                    <v-col class="mx-auto" cols="12" sm="6">
                        <v-form ref="form" v-on:submit.prevent="SaveSlider">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field :rules="[requireRule]" v-model="name" hide-details
                                        label="نام اسلایدر" placeholder=" " dense outlined>
                                        <template #label>
                                            نام اسلایدر  <span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete :items="lang_items" :rules="[requireRule]" v-model="langSelected"
                                        hide-details label="انتخاب زبان" placeholder=" " dense outlined>
                                        <template #label>
                                            انتخاب زبان<span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col class="mt-3" cols="12">
                                    <BoxImages ref="fileManager" @uploadDone="getImgUrl" />
                                    <!-- @setImgUrl="getImgUrl" -->
                                    <v-btn @click="$refs.fileManager.dialog = true" width="100%" v-bind="attrs" v-on="on">
                                        انتخاب عکس
                                    </v-btn>
                                    <v-card>
                                        <v-img class="ma-3 text-center mx-auto" width="200" v-if="image" :src="$BaseUrl+image"></v-img>
                                    </v-card>
                                </v-col>
                                <v-col cols="12">
                                    <v-btn width="100%" height="40" class="white--text" depressed color="#02c9b7"
                                        type="submit">ذخیره</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import BoxImages from '../../components/Images.vue'
    export default {
        props: ['slider_id'],
        data() {
            return {
                name: '',
                loader: false,
                map: null,
                tileLayer: null,
                mapMarkers: [],
                // imgPath: '',
                imgPath2: '',
                image : '',
                image2 : '',
                type: '',
                layers: [{
                    id: 0,
                    name: 'Requests',
                    active: true,
                    features: [],
                }, ],
                lang_items: [{
                    text: 'فارسی',
                    value: 'fa'
                }, {
                    text: 'انگلیسی',
                    value: 'en'
                }],
                langSelected:'fa',
            }
        },
        components: {
            BoxImages
        },
        created() {
            if (this.slider_id) {
                this.getSlider()
            }
        },
        methods: {
            SaveSlider() {
                var valid = this.$refs.form.validate();
                if (!valid)
                    return;
                this.loader = true
                var method = ''
                var url = ''
                if (this.slider_id) {
                    method = 'put'
                    url = '/admin/slider/edit/' + this.slider_id
                } else {
                    method = 'post'
                    url = '/admin/slider/add'
                }
                this.request({
                        method: method,
                        url: url,
                        data: {
                            name: this.name,
                            image: this.image,
                            lang:this.langSelected
                        }
                    })
                    .then((response) => {
                        //this.$refs.form.reset();
                        this.$notify({
                            title: 'انجام شد',
                            text: 'با موفقیت انحام شد',
                            group: 'foo',
                            type: 'success',
                        });
                        this.$router.push({
                            name: 'list_slider'
                        })
                    })
                    .catch(error => {})
                    .finally(x => {
                        this.loader = false
                    })
            },
            getSlider() {
                this.loader = true
                this.request({
                        method: 'get',
                        url: '/admin/slider/single/' + this.slider_id,
                    })
                    .then((response) => {
                        this.name = response.data.name,
                        this.image = response.data.image,
                        this.langSelected=response.data.lang
                    })
                    .catch(error => {})
                    .finally(x => {
                        this.loader = false
                    })
            },
            getImgUrl(e) {
                this.image = e
            },
            // uploadImg() {
            //     this.loader = true
            //     var formData = new FormData()
            //     formData.append('file' , this.imgPath)
            //     this.request({
            //             method: 'post',
            //             url: '/admin/upload',
            //             data : formData
            //         })
            //         .then((response) => {
            //            this.image = response.url
            //         })
            //         .catch(error => {})
            //         .finally(x => {
            //             this.loader = false
            //         })
            // },
        }
    }
</script>

<style>

</style>
